import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { HomePageLayoutBlueprint } from '@backstage/plugin-home-react/alpha';

export const homeModule = createFrontendModule({
  pluginId: 'home',
  extensions: [
    HomePageLayoutBlueprint.make({
      name: 'kpc',
      params: {
        loader: () =>
          import('./components/home-layout').then(m => m.HomeLayout),
      },
    }),
  ],
});
